import {HelpWizard} from "./HelpWizard";

export class TourController {

    constructor() {
        this.activeTour = null;
        this.tourName = null;
        this.tour = null;
    }

    setActiveTour(tour){
        this.tour = tour;
        this.tourName = tour.name;
        this.tour.createTour();
    }

    hasActiveTour() {
        console.log(1, this.tour.tour.isActive());
        if(this.tour){
            return !!this.tour.tour.isActive();
        }
    }

    getActiveTourName() {
        if(this.tour){
            return this.tour.name;
        }
    }

    removeActiveTour() {
        this.activeTour = null;
        this.tourName = null;
        this.tour = null;
    }

    cancelActiveTour() {
        if(this.tour){
            return !!this.tour.tour.cancel();
        }
    }

    getCurrentStep(){
        return this.tour.tour.getCurrentStep();
    }

    startActiveTour(){
        this.tour.startTour();
    }

    nextStep(){
        this.tour.nextTourStep();
    }

    previousStep(){
        this.tour.previousTourStep();
    }

    cancel(){
        this.tour.cancelTour();
        this.removeActiveTour();
    }

    complete(){
        this.tour.completeTour();
        this.removeActiveTour();
    }

    addStep(step, index= null){
        this.tour.addTourStep(step, index);
    }

    removeStep(stepId) {
        this.tour.removeTourStep(stepId);
    }

    updateStep(step, index){
        if(!index){
            throw new Error('index cannot be empty');
        }

        this.tour.updateTourStep(step, index);
    }
}
